import { Component, EventEmitter, Input, Output, OnDestroy, OnInit , signal } from '@angular/core';
import { FollowModeState } from 'src/app/models/follow-mode-states';
import { SettingsService } from 'src/app/services/account/settings.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-follow-mode',
  imports: [],
  templateUrl: './follow-mode.component.html',
  styleUrl: './follow-mode.component.scss'
})
export class FollowModeComponent implements OnInit, OnDestroy {

  @Input() followModeState!: FollowModeState;
  @Output() followModeOnClicked = new EventEmitter<Boolean>();

  private skinSubscription!: Subscription;
  /** Signal-backed so a skin change re-renders the icons without a manual refresh. */
  private readonly iconPath = signal<string>('assets/icons/default/follow_mode/');

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.skinSubscription = this.settingsService.ObservableMap.subscribe(mapSettings => {
      this.iconPath.set(`assets/icons/${mapSettings?.Skin}/follow_mode/`);
    });
  }

  ngOnDestroy(): void {
    if (this.skinSubscription) {
      this.skinSubscription.unsubscribe();
    }
  }

  public followModeOnClick() {
    this.followModeOnClicked.emit(true);
  }

  public get getFollowModeIcon(): string {
    switch (this.followModeState) {
      case FollowModeState.PANNED:
        return `${this.iconPath()}center_icon.svg`;
      case FollowModeState.TWO_D_FOLLOW:
        return `${this.iconPath()}3d_view_icon.svg`;
      case FollowModeState.THREE_D_FOLLOW:
        return `${this.iconPath()}lock_north_icon.svg`;
      case FollowModeState.TWO_D_NORTH:
        return `${this.iconPath()}center_icon.svg`;
      default:
        return `${this.iconPath()}center_icon.svg`;
    }
  }
}
